import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('goal_preferences_unique', ['entityType', 'entityId', 'goal'], {
	unique: true,
})
@Index('idx_goal_preferences_deleted', ['deletedDate'], {})
@Index('idx_goal_preferences_entity', ['entityType', 'entityId'], {})
/**
 * Legacy per-user / per-team / per-company goal-metric enablement.
 *
 * No longer read or written: PD-13518 replaced it with the tenant-wide
 * `goals.visible_kpis` instance setting. The entity stays registered so the
 * table (and its historical rows) survive untouched until PD-15875 drops both.
 */
@Entity('goal_preferences')
export class GoalPreferencesEntity extends BaseEntity {
	@Column('varchar', { name: 'goal', nullable: false, length: 50 })
	public goal!: string;

	@Column('enum', { name: 'entity_type', enum: ['user', 'team', 'company'] })
	public entityType!: 'user' | 'team' | 'company';

	@Column('int', { name: 'entity_id', unsigned: true })
	public entityId!: number;
}
